import { render, staticRenderFns } from "./PreviewEmailButton.vue?vue&type=template&id=015f2830"
import script from "./PreviewEmailButton.vue?vue&type=script&lang=js"
export * from "./PreviewEmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports